module.exports = __webpack_public_path__ + "img/logo.94d3f338.png";